import classNames from "classnames";
import React, { InputHTMLAttributes, useState } from "react";
import "./radio.scss";

export interface TRadio extends InputHTMLAttributes<HTMLInputElement> {
    label?: string;
    hiddenLabel?: boolean;
    onDarkBackground?: boolean;
    buttonStyle?: boolean;
}

export const Radio = ({
    label,
    name,
    value,
    hiddenLabel = false,
    disabled,
    onDarkBackground = false,
    buttonStyle = false,
    ...inputProps
}: TRadio) => {
    const [internalChecked, setInternalChecked] = useState(inputProps.defaultChecked || false);
    const isControlled = inputProps.checked !== undefined;
    const currentChecked = isControlled ? inputProps.checked : internalChecked;

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (!isControlled) {
            setInternalChecked(e.target.checked);
        }
        inputProps.onChange?.(e);
    };

    return (
        <div
            className={classNames("c-radio", {
                "c-radio--on-dark-bg": onDarkBackground,
                "c-radio--hidden-label": label && hiddenLabel,
                "c-radio--disabled": disabled,
                "c-radio--button-style-checked-radio": buttonStyle && currentChecked,
                "c-radio--button-style-unchecked-radio": buttonStyle && !currentChecked,
            })}
        >
            <label className="c-radio__label">
                <input
                    {...inputProps}
                    type="radio"
                    name={name}
                    value={value}
                    className="c-radio__input"
                    checked={currentChecked}
                    onChange={handleChange}
                    aria-label={inputProps["aria-label"]}
                />
                <span className="c-radio__label-text">{label}</span>
                <span className="c-radio__checkmark" aria-hidden="true"></span>
            </label>
        </div>
    );
};

export default Radio;
